import { useTranslation } from 'react-i18next';
import { Text } from '@connect-x-app/hybrid-ui';
import { COLORS, LAYERS } from '@connect-x-app/shared-ui';
import { Icon } from '@connect-x-app/web-ui';

import { Button } from '../button/Button';

import './DeleteButton.scss';

type Props = {
  disabled?: boolean;
  label?: string;
  onClick: () => void;
  testId?: string;
};

/**
 * The pill-shaped delete button that lives in a table's actions bar. The icon is a child rather
 * than `Button`'s `iconName` for two reasons: `Icon` sizes itself with an inline style CSS cannot
 * override (the design wants 16px, not the 20px default), and it needs an explicit `colorName` —
 * the trash SVG hardcodes its own fill and only follows `currentColor` once `Icon` adds its
 * `custom-color` class, so without this the bin stays grey-blue while the label turns red.
 */
export const DeleteButton = ({ disabled = false, label, onClick, testId }: Props) => {
  const { t } = useTranslation();

  return (
    <Button className="delete-button-pill" disabled={disabled} isOutline onClick={onClick} testId={testId} theme="delete">
      <Icon colorName={disabled ? LAYERS.labelColors['$label-disabled'] : COLORS.etna.$06} name="trash" size={1.6} />
      <Text as="span" size="XS" weight="bold">
        {label ?? t('SHARED.BUTTONS.DELETE')}
      </Text>
    </Button>
  );
};
